import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/Library.css';
import getBookCoverUrl from '../utils/getBookCoverUrl';
// DEĞİŞİKLİK: 'Search' ikonu import satırından kaldırıldı.
import { AlertCircle } from 'lucide-react'; 

const Library = () => {
    // ... (diğer state ve fonksiyonlar aynı kalıyor) ...
    // handleBookClick, filteredBooks, sortedBooks fonksiyonları değişmeden kalacak.
    const [books, setBooks] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('alphabetical');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchReadingList = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            try {
                const response = await api.get('/library/reading-list', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const updatedBooks = response.data.map(book => ({
                    ...book,
                    cover_image_url: getBookCoverUrl(book.cover_image_url)
                }));
                setBooks(updatedBooks);
            } catch (error) {
                console.error('Kütüphane listesi alınırken hata:', error);
                setError('Kütüphaneniz getirilemedi. Lütfen tekrar deneyin.');
                if (error.response?.status === 401) {
                    localStorage.removeItem('token');
                    navigate('/login');
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchReadingList();
    }, [navigate]);

    const handleBookClick = (bookId) => {
        navigate(`/book/${bookId}`);
    };

    const filteredBooks = books.filter(book =>
        book.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedBooks = [...filteredBooks].sort((a, b) => {
        if (sortBy === 'alphabetical') return a.title.localeCompare(b.title, 'tr');
        if (sortBy === 'lastRead') return new Date(b.last_read) - new Date(a.last_read);
        return 0;
    });


    if (isLoading) {
        return <div className="loading-state">Kütüphaneniz yükleniyor...</div>;
    }

    if (error) {
        return (
            <div className="error-state">
                <AlertCircle size={48} />
                <p>{error}</p>
            </div>
        );
    }


    return (
        <div className="library-page">
            <header className="library-header">
                <h1 className="library-title">Kütüphanem</h1>
                <div className="controls-container">
                    <div className="search-wrapper">
                        {/* DEĞİŞİKLİK: Search ikonu bu div içerisinden kaldırıldı. */}
                        <input
                            type="text"
                            placeholder="Kütüphanenizde arayın..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input"
                        />
                    </div>
                    <div className="sort-buttons">
                        <button
                            className={`sort-button ${sortBy === 'alphabetical' ? 'active' : ''}`}
                            onClick={() => setSortBy('alphabetical')}
                        >
                            Alfabetik
                        </button>
                        <button
                            className={`sort-button ${sortBy === 'lastRead' ? 'active' : ''}`}
                            onClick={() => setSortBy('lastRead')}
                        >
                            Son Okunan
                        </button>
                    </div>
                </div>
            </header>

            <main className="book-grid">
                {/* ... (kitap listeleme kısmı aynı kalıyor) ... */}
                {sortedBooks.length > 0 ? (
                    sortedBooks.map(book => (
                        <div key={book.book_id} className="book-card" onClick={() => handleBookClick(book.book_id)}>
                            <img
                                src={book.cover_image_url}
                                alt={book.title}
                                className="book-cover"
                                loading="lazy"
                            />
                        </div>
                    ))
                ) : (
                    <div className="no-books-found">
                        <p>Aramanızla eşleşen kitap bulunamadı.</p>
                    </div>
                )}
            </main>
        </div>
    );
};

export default Library;